import React from "react";
import theme from "app/Theme/Theme";
import { StyleSheet } from "react-native";
import * as Animatable from "react-native-animatable";

const styles = StyleSheet.create({
  main: {
    paddingHorizontal: theme.spacing.sm,
    paddingVertical: theme.spacing.m,
    borderRadius: 10,
    backgroundColor: theme.colors["neutral.white"],
  },
});

const AnimatedBox = ({ children, style }) => {
  return (
    <Animatable.View
      useNativeDriver
      delay={50}
      animation="fadeInUp"
      style={[styles.main, style && style]}
    >
      {children}
    </Animatable.View>
  );
};

export default AnimatedBox;
